export default "__VITE_ASSET__u2u3Y7rb__"